module.exports = __webpack_public_path__ + "static/cateau4-8e9ca140022110c9f4d8eb7cdfce287d.png";